export class PageScrollerService {
  public scrollTop(behavior?: 'smooth'): void {
    window.scrollTo({ top: 0, behavior: behavior });
  }
}

export const pageScrollerService: PageScrollerService = new PageScrollerService();
